"use strict";

import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useEffect, useState } from "react";
import { CaptureFieldDefinition } from "./CaptureFieldDefinition";
import { utc } from "moment";

type CaptureProfileContextType = {
    fields: CaptureFieldDefinition[],
    setFields: Dispatch<SetStateAction<CaptureFieldDefinition[]>> | null,
    updateFieldValue: ((alias: string, value: string) => void) | null,
    privileges: string[]
}

export const CaptureProfileContext : React.Context<CaptureProfileContextType> = 
    createContext<CaptureProfileContextType>(undefined!);


export const useCaptureProfileContext = () => {
    const context = useContext(CaptureProfileContext);

    if (context === undefined) {
		throw new Error('useCaptureProfileContext must be used within a CaptureProfileContextProvider')
	}
    return context
}

export const CaptureProfileContextProvider = ({fieldDefinitions, children} : {fieldDefinitions: CaptureFieldDefinition[], children: ReactNode}) => {

    const [fields, setFields] = useState<CaptureFieldDefinition[]>(fieldDefinitions);
    const [privileges, setPrivileges] = useState<string[]>([]);

    useEffect(() => {
        const abort = new AbortController();
        fetch(`/profile/privileges?_=${(new Date).getTime() / 1000}`,
        {
            method: 'get',
            signal: abort.signal
        }
        )
            .then(response => response.json())
            .then(data => {
                if(data) setPrivileges(data);
            })
            .catch((e)=> {
                if(console && e.name === 'AbortError') console.info("request aborted by calendar navigation");
                else if(console) console.error(e);
            });
        
    },[]);

    const updateFieldValue = (alias: string, value: string) => {
        if(setFields) setFields((prev) => {
            const updated = [...prev];

            let match = updated.find((p) => p.alias === alias);
            if(match) match.value = value;
            return updated;
        })
    }

    return <CaptureProfileContext.Provider value={{fields, setFields, updateFieldValue, privileges}}>
        {children}
    </CaptureProfileContext.Provider>
}
